import {bindable} from "aurelia-framework";
import * as _ from "lodash";

export class ReadonlyCell {
    @bindable item;
    @bindable column;

    _column;

    columnChanged()
    {
        if (!this.column) {
            this._column = undefined;
            return;
        }

        this._column = _.clone(this.column.modelField);
        this._column.property = this.column.property;
    }
}
